import axios from "axios";
import {mapGetters} from "vuex";

let acceptSystematix = 'application/x.systematix.v1+json'
let acceptPythia = 'application/x.systematix.pythia-v1+json'

export default {
    computed: {
        ...mapGetters('auth', [
            'getToken',
        ]),
    },
    methods: {
        getAxiosConfig(accept) {
            if(!accept) {
                accept = acceptPythia
            }

            return {
                headers: {
                    Accept: accept,
                    Authorization: 'Bearer' + this.getToken
                }
            }
        },

        callApi(url, data, config) {
            return new Promise((resolve, reject) => {
                    axios.post(url, data, config)
                        .then((res) => {
                            resolve(res)
                        }).catch((err) => {
                        reject(err)
                        console.log(err);
                    })
                }
                , 1000)
        },

        submitBookingNotes(data) {
            let config = this.getAxiosConfig(acceptSystematix)
            return this.callApi('/api/bookingNotes', data, config)
        },

        submitEvent(data){
            let config = this.getAxiosConfig()

            const formData = new FormData()
            Object.keys(data).forEach(key => formData.append(key, data[key]));

            return this.callApi('/api/eventLogs', formData, config)
        },

        generatePo(poId) {
            let config = this.getAxiosConfig()

            const formData = new FormData()
            formData.append('purchaseOrderId', poId)

            return this.callApi('/api/xero/purchaseOrders', formData, config)
        },

        emailPo(poId) {
            let config = this.getAxiosConfig('application/json')
            return this.callApi('/api/purchaseOrders/' + poId + '/sendMail', {}, config)
        },

        sendJoiningInstructions(classId) {
          let config = this.getAxiosConfig('application/json')
          return this.callApi('/api/trainingClasses/' + classId + '/sendJoiningInstructions', {}, config)
        }
    }
};
